import React, { FC } from 'react';
import style from './style.module.less';
import { Button, Dialog } from '@galaxy-ds/core';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  title: string;
  children: React.ReactNode;
  onClose: () => void;
}

export const InfoModal: FC<Props> = (props) => {
  const { isOpen, onClose, title, children } = props;
  const { t } = useTranslation();
  return (
    <Dialog
      title={title}
      open={isOpen}
      variant='plain'
      message={children}
      handleClose={onClose}
      PaperProps={{ className: style.paper }}
    >
      <div className={style.container}>
        <Button
          variant='contained'
          color='primary'
          onClick={onClose}
          className={style.button}
        >
          {t('confirm.close')}
        </Button>
      </div>
    </Dialog>
  );
};
